<template>
  <el-backtop :target="el" :bottom="30" :right="30">
    <div
      style="
         {
          height: 100%;
          width: 100%;
          background: rgba(0, 0, 0, 0);
          text-align: center;
          color: #f39518;
          display: flex;
          font-size: 16px;
          flex-flow: colum;
        }
      "
    >
      ^ Top
    </div>
  </el-backtop>
</template>
<script>
export default {
  name: "wx-backtop",
  props: {
    el: {
      type: String,
      default: ".maxbox",
    },
  },
};
</script>
<style lang='less'>
/deep/ .el-backtop {
  background-color: none;
}
</style>


// WEBPACK FOOTER //
// src/components/backtop/index.vue